import styles from './AcceptDeclineInvite.module.css';
import { useLeague } from '../utils/LeagueContext';
import { useUser } from '../UserContext';
import API_BASE_URL from '../utils/apiConfig';


const AcceptDeclineInvite = ({ entity = 'data', className }) => {
  const { selectedLeague, setSelectedLeague, setSelectedLeagueAndId } = useLeague();
  const { user } = useUser();

  if (!selectedLeague || !selectedLeague._id) return null;

  const handleAcceptInvite = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/user/leagues/accept-invite/${selectedLeague._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`,
        },
      });

      if (!response.ok) {
        const data = await response.json();
        alert(data.message || 'Failed to accept invite');
        return;
      }

      const result = await response.json();

      // Force refetch of selectedLeague even if ID hasn't changed
      await setSelectedLeagueAndId(selectedLeague.leagueId, true);

    } catch (err) {
      console.error('Error accepting invite:', err);
      alert('An error occurred while accepting the invite.');
    }
  };

  const handleDeclineInvite = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/user/leagues/decline-invite/${selectedLeague._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      if (!response.ok) {
        const data = await response.json();
        alert(data.message || 'Failed to decline invite');
        return;
      }

      // Clear the selectedLeague and localStorage immediately
      localStorage.removeItem('leagueId');
      setSelectedLeague(null);

      alert('You have declined the invite.');
      window.location.reload(); // Force full refresh to sync state
    } catch (err) {
      console.error('Error declining invite:', err);
      alert('An error occurred while declining the invite.');
    }
  };

  return (
    <>
      <div className={styles.inviteMessage}>
        <h4>Accept your invite to see league details.</h4>
      </div>
      <div className={styles.inviteButtons}> 
        <button className={styles.acceptInvite} onClick={handleAcceptInvite}>
          Accept Invite
        </button>
        <p className={styles.declineInvite}>
          <a href="#" onClick={handleDeclineInvite}>
            Decline Invite
          </a>
        </p>
      </div>
    </>
  );
};

export default AcceptDeclineInvite;

